"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const Sentry = __importStar(require("@sentry/browser"));
const mithril_1 = __importDefault(require("mithril"));
const moment_1 = __importDefault(require("moment"));
require("moment/locale/fr");
require("./app.scss");
const venue_1 = require("./model/venue");
const auth_1 = require("./utils/auth");
const delayed_1 = require("./utils/delayed");
moment_1.default.locale('fr');
let settings = {};
exports.App = {
    _serviceURL: BACKEND_URL,
    exitConfirmation: undefined,
    started: false,
    serviceURL(path, opts) {
        opts = opts || {};
        let url = `${this._serviceURL}${path}`;
        url = url + (url.indexOf("?") === -1 ? '?' : '&');
        for (let k in opts) {
            url = url.replace(`:${k}`, encodeURI(opts[k]));
        }
        return url;
    },
    get(path, data = {}) {
        return mithril_1.default.request({
            method: "GET",
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: this.serviceURL(path, data)
        });
    },
    patch(path, data) {
        return mithril_1.default.request({
            method: "PATCH",
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: this.serviceURL(path, data),
            data: data
        });
    },
    post(path, data = {}) {
        return mithril_1.default.request({
            method: "POST",
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: this.serviceURL(path, data),
            data: data
        });
    },
    delete(path, data = {}) {
        return mithril_1.default.request({
            method: "DELETE",
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: this.serviceURL(path, data),
        });
    },
    reloadSettings() {
        // Prevent issue in the loading order by requiring settings only on init call....
        const { SettingsProvider } = require('./model/settings');
        SettingsProvider.show(0).then((data) => {
            settings = data;
        });
    },
    start() {
        this.started = true;
        mithril_1.default.route.prefix('#');
        mithril_1.default.route(document.getElementById("app"), '/&', auth_1.Auth.mode().routes);
        this.reloadSettings();
        auth_1.Auth.refreshToken();
        (0, venue_1.loadVenues)();
    },
    getSettings(key, def) {
        return settings[key] || def;
    },
    moment(x) { return moment_1.default.tz(x, exports.App.BOOKING_TIMEZONE); },
    longDateFormat(x) { return (0, moment_1.default)(x).format("dddd DD MMMM YYYY"); },
    shortDateFormat(x) { return (0, moment_1.default)(x).format("DD/MM/YY"); },
    parseLongDateFormat(x) { return moment_1.default.tz(x, "dddd DD MMMM YYYY"); },
    parseShortDateFormat(x) { return moment_1.default.tz(x, "DD/MM/YY"); },
    get BOOKING_MIN_DURATION() {
        return auth_1.Auth.isAdmin() ? this.BOOKING_MIN_DURATION_ADMIN : this.BOOKING_MIN_DURATION_CLIENT;
    },
    get VAT_RATE() {
        return parseFloat(this.getSettings("vat", "0.2"));
    },
    ENV: ENV,
    BOOKING_MIN_DURATION_CLIENT: 60,
    BOOKING_MIN_DURATION_ADMIN: 30,
    BOOKING_STEP: 30,
    BOOKING_TIMEZONE: "Europe/Paris",
    CLIENT_TYPE: {
        "company": "Société",
        "auto_entreprise": "Auto-entrepreneur",
        "portage": "Portage salarial",
        "association": "Association",
        "student": "Étudiant",
        "liberal": "Liberal",
        "other": "Autre",
    }
};
Sentry.init({
    dsn: 'https://b1680bd2e6e74b4b82940539fd5673cc@o292794.ingest.sentry.io/5417443',
    tracesSampleRate: 1.0,
});
document.addEventListener("readystatechange", (_evt) => {
    if (document.readyState == "complete") {
        exports.App.start();
    }
});
window.addEventListener("resize", (_evt) => {
    (0, delayed_1.delayed)("resize", () => { mithril_1.default.redraw(); }, 20);
});
